// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","header-fire":"Header_header-fire__1evi8","header-grass":"Header_header-grass__3AtxR","boxHeader":"Header_boxHeader__2wQ7e"};